import { screenSmMin, screenXsMax } from '@spotify-internal/encore-foundation';
import { cssSpacing } from "../../styles/index.mjs";
import styled from "../../styled-components.mjs";
export var HeaderNav = styled.div.withConfig({
  displayName: "HeaderNav",
  componentId: "sc-1lmh14x-0"
})(["@media (max-width:", "){display:none;}@media (min-width:", "){margin-block-end:calc(-1 * ", ");margin-block-start:", ";}"], screenXsMax, screenSmMin, cssSpacing('looser', '20px'), cssSpacing('tighter-2', '8px'));